import { getMargin as i } from "./highrise679.mjs";
function f(t) {
  const {
    left: o,
    right: r,
    top: n,
    bottom: e
  } = i(t);
  return `${n} ${o} ${e} ${r}`;
}
export {
  f as rtlInset
};
